import React from 'react';
import './App.css';
import EventCalendar from "./components/EventCalendar"
import AudioComponent from "./components/Audio"
import Snowfall from 'react-snowfall'

function App() {
  return (
    <>
      <AudioComponent />
      <Snowfall
        style={{ height: '20%' }}
        // Controls the number of snowflakes that are created (defaults to 150).
        snowflakeCount={30}
      />
      <EventCalendar />
    </>
  )
}

export default App
